// extracted by css-extract-rspack-plugin
export default {"checkboxContainer":"checkbox-container--VHzWHkajIboHEuHO"};